import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "feedback-container"
}
const _hoisted_2 = { class: "subtitle-2" }
const _hoisted_3 = {
  key: 1,
  class: "page-loading"
}
const _hoisted_4 = {
  key: 2,
  class: "feedback-container"
}
const _hoisted_5 = { class: "subtitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AttensiLoadingSpinner = _resolveComponent("AttensiLoadingSpinner")!
  const _component_Leaderboard = _resolveComponent("Leaderboard")!

  return (_ctx.error)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.error.message), 1)
      ]))
    : (!_ctx.leaderboard)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_AttensiLoadingSpinner)
        ]))
      : (_ctx.isLeaderboardEmpty)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('leaderboard.empty')), 1)
          ]))
        : (_openBlock(), _createBlock(_component_Leaderboard, {
            key: 3,
            leaderboard: _ctx.leaderboard,
            title: _ctx.title,
            timer: _ctx.timer,
            "is-loading": _ctx.isLoading,
            "user-display-format": _ctx.userDisplayFormat
          }, null, 8, ["leaderboard", "title", "timer", "is-loading", "user-display-format"]))
}